(function (global) {
  'use strict';

  var ADDED_MS = 1400;

  function requestJson(url, options) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, options || {})).then(
      function (response) {
        if (!response.ok) {
          return response.json().catch(function () {
            return {};
          }).then(function (body) {
            var error = new Error((body && body.description) || 'Cart request failed');
            error.status = response.status;
            error.body = body;
            throw error;
          });
        }
        return response.json();
      }
    );
  }

  function setAddedState(button) {
    if (!button) return;
    if (!button.dataset.chiijeOriginalLabel) {
      button.dataset.chiijeOriginalLabel = button.textContent;
    }
    button.textContent = 'Added';
    button.disabled = true;
    window.clearTimeout(button._chiijeAddedTimer);
    button._chiijeAddedTimer = window.setTimeout(function () {
      button.textContent = button.dataset.chiijeOriginalLabel;
      button.disabled = false;
    }, ADDED_MS);
  }

  function notifyHorizonCart(cart, action) {
    var event = new Event('shopify:cart:lines-update', { bubbles: true });
    event.action = action || 'add';
    event.promise = Promise.resolve({
      cart: { totalQuantity: cart.item_count },
      detail: {
        items: cart.items,
        itemCount: cart.item_count,
        source: 'chiije-cart',
        didError: false,
      },
    });
    document.dispatchEvent(event);
  }

  var ChiijeCart = {
    add: function (variantId, quantity, properties, button) {
      var payload = {
        id: Number(variantId),
        quantity: quantity == null ? 1 : Number(quantity),
      };
      if (properties && typeof properties === 'object') {
        payload.properties = properties;
      }

      return requestJson(
        global.Shopify && global.Shopify.routes && global.Shopify.routes.root
          ? global.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        }
      ).then(function (item) {
        setAddedState(button);
        return ChiijeCart.get().then(function (cart) {
          ChiijeCart.updateBasketCount(cart);
          notifyHorizonCart(cart, 'add');
          document.dispatchEvent(
            new CustomEvent('chiije:cart:add', { detail: { item: item, cart: cart } })
          );
          return item;
        });
      });
    },

    get: function () {
      var root =
        global.Shopify && global.Shopify.routes && global.Shopify.routes.root
          ? global.Shopify.routes.root
          : '/';
      return requestJson(root + 'cart.js');
    },

    updateBasketCount: function (cart) {
      var apply = function (data) {
        var count = data && typeof data.item_count === 'number' ? data.item_count : 0;
        var label = count > 99 ? '99+' : String(count);

        document.querySelectorAll('[data-chiije-basket-count]').forEach(function (el) {
          el.textContent = label;
        });

        document.querySelectorAll('[data-testid="cart-bubble"], .cart-bubble__text-count').forEach(function (el) {
          el.textContent = label;
          el.classList.toggle('hidden', count === 0);
        });

        document.querySelectorAll('.cart-bubble').forEach(function (el) {
          el.classList.toggle('visually-hidden', count === 0);
        });

        document.querySelectorAll('.theme-drawer__badge').forEach(function (el) {
          el.textContent = label;
          el.classList.toggle('visually-hidden', count === 0);
        });

        document.dispatchEvent(
          new CustomEvent('cart:update', { detail: { cart: data, itemCount: count } })
        );
        return data;
      };

      if (cart && typeof cart.item_count === 'number') {
        return Promise.resolve(apply(cart));
      }
      return ChiijeCart.get().then(apply);
    },

    setAddedState: setAddedState,
  };

  global.ChiijeCart = ChiijeCart;

  function updateProductSpecs(variantId) {
    document.querySelectorAll('[data-chiije-product-specs]').forEach(function (root) {
      var script = root.parentElement
        ? root.parentElement.querySelector('[data-chiije-variant-specs]')
        : null;
      if (!script) {
        script = document.querySelector(
          '[data-chiije-variant-specs][data-product-id="' + root.dataset.productId + '"], [data-chiije-variant-specs]'
        );
      }
      if (!script || !script.textContent) return;
      var map;
      try {
        map = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
      var specs = map[String(variantId)];
      if (!specs) return;
      var burnEl = root.querySelector('[data-chiije-spec="burn_time"]');
      var netEl = root.querySelector('[data-chiije-spec="net_wt"]');
      if (burnEl && specs.burn_time) burnEl.textContent = specs.burn_time;
      if (netEl && specs.net_wt) netEl.textContent = specs.net_wt;
    });
  }

  function bindProductSpecs() {
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest('variant-picker, product-form-component, form[action*="/cart/add"]')) return;
      var form = target.closest('form');
      var idInput = form && form.querySelector('[name="id"]');
      if (idInput && idInput.value) updateProductSpecs(idInput.value);
    });

    document.addEventListener('product:variant-change', function (event) {
      var variant = event.detail && (event.detail.variant || event.detail.selectedVariant);
      if (variant && variant.id) updateProductSpecs(variant.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ChiijeCart.updateBasketCount();
      bindProductSpecs();
    });
  } else {
    ChiijeCart.updateBasketCount();
    bindProductSpecs();
  }
})(typeof window !== 'undefined' ? window : this);
